import { render, staticRenderFns } from "./MspAddTest.vue?vue&type=template&id=4abe60bb"
import script from "./MspAddTest.vue?vue&type=script&lang=js"
export * from "./MspAddTest.vue?vue&type=script&lang=js"
import style0 from "./MspAddTest.vue?vue&type=style&index=0&id=4abe60bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports